"use client";
import React, { useState, useEffect } from "react";
import states from "../../../public/states.json";
import countries from "../../../public/countries.json";
import ContactAlert from "../../_components/alerts/ContactAlert";
import { sendFormEvent, sendLeadGenerationEvent } from "../../ga4/eventHandler";

export default function DemoRequestForm() {
  const [clientIp, setClientIp] = useState("");
  let initState = {
    origin: "KO_Website",
    company: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    website: "",
    fname: "",
    title: "",
    phone: "",
    mphone: "",
    email: "",
    numLocs: "",
    comment: "",
    current: 0,
    newsLetter: 0,
    ip: clientIp,
  };
  const [formData, setFormData] = useState(initState);
  const [errors, setErrors] = useState({});
  const [alertStatus, setAlertStatus] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [formStarted, setFormStarted] = useState(false);

  countries.sort((a, b) => {
    if (a.name === "United States") {
      return -1;
    }
    if (b.name === "United States") {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });

  useEffect(() => {
    async function fetchClientIp() {
      try {
        const response = await fetch("https://api64.ipify.org?format=json");
        const data = await response.json();
        setClientIp(data.ip);
      } catch (error) {
        console.error("Error fetching client IP:", error);
      }
    }
    fetchClientIp();
  });

  // Helper function to validate URL

  const validateForm = () => {
    const newErrors = {};
    const websiteRegex = /^(https?:\/\/)?(www\.)?([\w-]+\.)+[\w]{2,}$/i;
    const fullNameRegex = /^[a-zA-Z\s'-]+$/;

    if (formData.company && !/^[a-zA-Z0-9\s\.\-_]+$/.test(formData.company)) {
      newErrors.company =
        "Company name must only contain letters, numbers, spaces, periods, hyphens, and underscores";
    } else if (formData.company && formData.company.length > 50) {
      newErrors.company = "Company name must not exceed 50 characters";
    }

    if (formData.title && formData.title.length > 50) {
      newErrors.title = "Job Title must not exceed 50 characters";
    }

    if (!formData.fname) {
      newErrors.fname = "Full name is required";
    } else if (!fullNameRegex.test(formData.fname)) {
      newErrors.fname = "Full name must only contain letters and spaces";
    } else if (formData.fname.length > 100) {
      newErrors.fname = "Full name must not exceed 100 characters";
    }

    if (!formData.address) {
      newErrors.address = "Address is required";
    } else if (formData.address.length > 50) {
      newErrors.address = "Address must not exceed 50 characters";
    }

    if (formData.address2 && formData.address2.length > 50) {
      newErrors.address2 = "Address must not exceed 50 characters";
    }

    if (!formData.city) {
      newErrors.city = "City is required";
    } else if (formData.city.length > 50) {
      newErrors.city = "City must not exceed 50 characters";
    }

    // State validation
    if (!formData.state) {
      newErrors.state = "State is required";
    } else if (formData.state.length > 50) {
      newErrors.state = "State must not exceed 50 characters";
    }

    // Country validation
    if (!formData.country) {
      newErrors.country = "Country is required";
    } else if (formData.country.length > 50) {
      newErrors.country = "Country must not exceed 50 characters";
    }

    // Zip validation
    if (!formData.zip) {
      newErrors.zip = "Zip is required";
    } else if (formData.zip.length > 50) {
      newErrors.zip = "Zip must not exceed 50 characters";
    }

    if (formData.website && !websiteRegex.test(formData.website)) {
      newErrors.website = "Invalid website URL";
    }

    if (!formData.phone) {
      newErrors.phone = "Phone is required";
    } else {
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(formData.phone)) {
        newErrors.phone = "Invalid phone number";
      }
      if (formData.phone.length > 10) {
        newErrors.phone = "Phone number exceeds maximum length";
      }
    }

    if (!formData.mphone) {
      newErrors.mphone = "Phone is required";
    } else {
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(formData.mphone)) {
        newErrors.mphone = "Invalid phone number";
      }
      if (formData.mphone.length > 10) {
        newErrors.mphone = "Phone number exceeds maximum length";
      }
    }

    // Validate email address
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Invalid email address";
      }
      if (formData.email.length > 50) {
        newErrors.email = "Email address exceeds maximum length";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if there are no errors
  };
  const requestDemo = async (data) => {
    let response = await fetch("/api/contact", {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    });
    response = await response.json();
    if (response.success) {
      setAlertStatus("Success");
      setShowAlert(true);
      setAlertMessage(response.message);
      return response;
    } else {
      setAlertStatus("Failed");
      setShowAlert(true);
      setAlertMessage(response.message);
      return response;
    }
  };
  const handleChange = (e) => {
    if (!formStarted) {
      setFormStarted(true);
      sendFormEvent("DEMO_REQUEST", "START");
    }
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    formData.ip = clientIp;
    if (validateForm()) {
      sendFormEvent("DEMO_REQUEST", "SUBMIT");
      let request = await requestDemo(formData);
      if (request.success) {
        sendLeadGenerationEvent("DEMO_REQUEST");
        setFormData(initState);
        setFormStarted(false);
      }
    } else {
      sendFormEvent("DEMO_REQUEST", "INVALID/ERROR");
    }
  };
  const closeAlert = () => {
    setShowAlert(false);
  };
  return (
    <div className="page padded">
      {showAlert && (
        <ContactAlert
          showAlert={showAlert}
          alertMessage={alertMessage}
          alertStatus={alertStatus}
          registeredSerial={null}
          closeAlert={closeAlert}
        />
      )}
      <form className="demo-form" onSubmit={handleSubmit}>
        <div className="form-section">
          <div className="section-title">
            <h4>Company Information</h4>
          </div>
          <div className="input-group">
            <label>
              Company Name
              {errors.company && (
                <label className="error">{errors.company}</label>
              )}
            </label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              placeholder="Company Name"
              onChange={handleChange}
            />
          </div>
          <div className="form-two-column">
            <div className="input-group">
              <label>
                Street Address
                {errors.address && (
                  <label className="error">{errors.address}</label>
                )}
              </label>
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                placeholder="123 Avenue"
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label>
                Suite
                {errors.address2 && (
                  <label className="error">{errors.address2}</label>
                )}
              </label>
              <input
                type="text"
                id="address2"
                name="address2"
                value={formData.address2}
                placeholder="Suite 42"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-three-column">
            <div className="input-group">
              <label>
                City
                {errors.city && <label className="error">{errors.city}</label>}
              </label>
              <input
                type="text"
                id="city"
                name="city"
                value={formData.city}
                placeholder="City"
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label>
                State
                {errors.state && (
                  <label className="error">{errors.state}</label>
                )}
              </label>
              <select
                onChange={handleChange}
                value={formData.state}
                name="state"
                id="state"
              >
                <option value={""}>Select State</option>
                {states.map((state, index) => (
                  <option value={state.abbreviation} key={index}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="input-group">
              <label>
                Zip
                {errors.zip && <label className="error">{errors.zip}</label>}
              </label>
              <input
                type="text"
                id="zip"
                name="zip"
                value={formData.zip}
                placeholder="12345"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-two-column">
            <div className="input-group">
              <label>
                Country
                {errors.country && (
                  <label className="error">{errors.country}</label>
                )}
              </label>
              <select
                onChange={handleChange}
                value={formData.country}
                name="country"
                id="country"
              >
                <option value={""}>Select Country</option>
                {countries.map((country, index) => (
                  <option value={country.id} key={index}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="input-group">
              <label>
                Website
                {errors.website && (
                  <label className="error">{errors.website}</label>
                )}
              </label>
              <input
                type="text"
                id="website"
                name="website"
                value={formData.website}
                placeholder="Website URL"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="form-section">
          <div className="section-title">
            <h4>Primary Contact Info</h4>
          </div>
          <div className="form-two-column">
            <div className="input-group">
              <label>
                Full Name
                {errors.fname && (
                  <label className="error">{errors.fname}</label>
                )}
              </label>
              <input
                type="text"
                id="fname"
                name="fname"
                value={formData.fname}
                placeholder="John Smith"
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label>
                Job Position
                {errors.title && (
                  <label className="error">{errors.title}</label>
                )}
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                placeholder="Job Position"
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label>
                Office Number
                {errors.phone && (
                  <label className="error">{errors.phone}</label>
                )}
              </label>
              <input
                type="phone"
                id="phone"
                name="phone"
                value={formData.phone}
                placeholder="123-456-7890"
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label>
                Mobile Number
                {errors.mphone && (
                  <label className="error">{errors.mphone}</label>
                )}
              </label>
              <input
                type="phone"
                id="mphone"
                name="mphone"
                value={formData.mphone}
                placeholder="123-456-7890"
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label>
                Email
                {errors.email && (
                  <label className="error">{errors.email}</label>
                )}
              </label>
              <input
                type="text"
                id="email"
                name="email"
                value={formData.email}
                placeholder="abcd@gmail.com"
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label>
                Number of Locations
                {errors.numLocs && (
                  <label className="error">{errors.numLocs}</label>
                )}
              </label>
              <input
                type="number"
                id="numLocs"
                name="numLocs"
                value={formData.numLocs}
                placeholder="1"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="input-group textarea">
          {/* textarea */}
          <label>
            Comments
            {errors.comment && (
              <label className="error">{errors.comment}</label>
            )}
          </label>
          <textarea
            type="text"
            id="comment"
            name="comment"
            value={formData.comment}
            placeholder="Comments"
            onChange={handleChange}
          />
        </div>
        <div className="button-wrapper"></div>
        <button className="form-submit" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
}
